import { HuntingSystem } from './HuntingSystem.js';

function assertMethod(value, method, name) {
  if (!value || typeof value[method] !== 'function') {
    throw new TypeError(`${name} must provide ${method}()`);
  }
}

export class TraversalHuntingSystem extends HuntingSystem {
  constructor({ traversalWorld, ...dependencies }) {
    assertMethod(traversalWorld, 'snapshot', 'traversalWorld');
    assertMethod(traversalWorld, 'restore', 'traversalWorld');
    super(dependencies);
    this.traversalWorld = traversalWorld;
  }

  eat(options = {}) {
    const traversalBackup = this.traversalWorld.snapshot();
    try {
      return super.eat(options);
    } catch (error) {
      try {
        this.traversalWorld.restore(traversalBackup);
      } catch (rollbackError) {
        throw new AggregateError(
          [error, rollbackError],
          'Meal transaction failed and traversal state could not be restored',
        );
      }
      throw error;
    }
  }
}
